// Error Display Component
import { XCircle } from 'lucide-react';

export const ErrorMessage = ({ message }) => {
   if (!message) return null;
   return (
      <div className="flex items-center gap-1 mt-1">
         <XCircle className="w-3 h-3 text-red-400 flex-shrink-0" />
         <span className="text-xs text-red-400">{message}</span>
      </div>
   );
};
